import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberResourceEdit',
  data: function data() {
    return {
      title: '',
      form: {
        resourceId: null,
        info: null,
        images: []
      },
      rules: {
        resourceId: [{
          required: true,
          message: '请输入资源ID',
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: '请输入资源信息',
          trigger: 'blur'
        }],
        images: [{
          required: true,
          message: '请输入图片',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.resourceId = null;
      this.form.info = null;
      this.form.images = [];
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.resourceId = data.resourceId;
      this.form.info = data.info;
      if (data.images !== null && data.images !== '') {
        this.form.images = JSON.parse(data.images);
      } else {
        this.form.images = [];
      }
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_BYMEMBERRESOURCE(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    removeImage: function removeImage(index) {
      var _this3 = this;
      this.$confirm('确定删除这张图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.form.images.splice(index, 1);
        _this3.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    saveApi: function saveApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_BYMEMBERRESOURCE(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.resourceId != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              if (_this5.form.images.length > 0) {
                _this5.form.images = JSON.stringify(_this5.form.images);
              } else {
                _this5.form.images = '';
              }
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};